<template>
  <div class="pageCentent">
    <!-- 搜索表单 -->
    <a-form-model size="small" layout="inline" @keyup.native.enter="search()">
      <a-form-model-item label="任务名称">
        <a-input
          placeholder="请输入任务名称"
          v-model="ajaxparams['title_like']"
        />
      </a-form-model-item>
      <a-form-model-item>
        <a-button icon="search" @click="$refs.myTable.search()" type="primary">
          搜索</a-button
        >
      </a-form-model-item>
    </a-form-model>

    <!-- 添加按钮 -->
    <a-button class="mt10" type="primary" @click="showAddDialog()">
      添加微信任务
    </a-button>

    <!-- 任务列表 -->
    <MyTable
      class="mt10"
      :isSelection="false"
      :apiUrl="apiUrl"
      :params="ajaxparams"
      ref="myTable"
      :columns="columns"
    >
      <a-space slot="img" slot-scope="item, row" @click="showImgPopup(item)">
        <img
          v-if="row.img"
          :src="IMGHOST + row.img"
          class="img"
          style="cursor: pointer"
        />
        <span v-else>-</span>
      </a-space>

      <a-space slot="content" slot-scope="item, row">
        <span :title="row.content">{{ row.content }}</span>
      </a-space>

      <a-space slot="user_levels" slot-scope="item, row">
        <a-tag
          v-for="level in splitCommaString(row.user_levels)"
          :key="level"
          color="blue"
          >{{ level }}</a-tag
        >
      </a-space>

      <a-space slot="user_ids" slot-scope="item, row">
        <span v-if="row.user_ids" :title="row.user_ids">
          {{ normalizeCommaString(row.user_ids) }}
        </span>
        <span v-else>-</span>
      </a-space>

      <a-space slot="forbidden_user_ids" slot-scope="item, row">
        <span v-if="row.forbidden_user_ids" :title="row.forbidden_user_ids">
          {{ normalizeCommaString(row.forbidden_user_ids) }}
        </span>
        <span v-else>-</span>
      </a-space>

      <a-space slot="is_expired" slot-scope="item, row">
        <a-tag :color="row.is_expired === 1 ? 'red' : 'green'">
          {{ row.is_expired === 1 ? "已过期" : "未过期" }}
        </a-tag>
      </a-space>
      <!-- <a-space slot="progress" slot-scope="item, row">
        <span>{{ row.take_num }} / {{ row.task_num }}</span>
      </a-space> -->
    </MyTable>

    <!-- 添加任务模态框 -->
    <a-modal
      title="添加微信任务"
      :visible="dialogVisible"
      @ok="submitTask"
      @cancel="cancelDialog"
      width="600px"
      :confirmLoading="submitLoading"
    >
      <a-form-model
        :model="form"
        :label-col="{ span: 6 }"
        :wrapper-col="{ span: 18 }"
      >
        <a-form-model-item label="任务名称" required>
          <a-input v-model="form.title" placeholder="请输入任务名称" />
        </a-form-model-item>

        <a-form-model-item label="发送内容" required>
          <a-textarea
            v-model="form.content"
            :rows="4"
            placeholder="请输入发送文字内容"
          />
        </a-form-model-item>

        <a-form-model-item label="任务图片">
          <MyUpload
            ref="upload"
            @result="uploadResult"
            @remove="uploadRemove"
            :list="form.img ? [form.img] : []"
          />
        </a-form-model-item>

        <a-form-model-item label="用户等级" required>
          <a-select
            v-model="form.user_levels"
            mode="multiple"
            placeholder="请选择用户等级"
            style="width: 100%"
          >
            <a-select-option value="primary">primary</a-select-option>
            <a-select-option value="junior">junior</a-select-option>
            <a-select-option value="vip">vip</a-select-option>
            <a-select-option value="A1">A1</a-select-option>
            <a-select-option value="A2">A2</a-select-option>
            <a-select-option value="A3">A3</a-select-option>
          </a-select>
        </a-form-model-item>

        <a-form-model-item label="用户ID">
          <a-input
            v-model="form.user_ids"
            placeholder="请输入用户ID，多个用逗号分隔"
            @blur="handleUserIdsInput"
          />
        </a-form-model-item>

        <a-form-model-item label="屏蔽用户ID">
          <a-input
            v-model="form.forbidden_user_ids"
            placeholder="请输入屏蔽用户ID，多个用逗号分隔"
            @blur="handleForbiddenUserIdsInput"
          />
        </a-form-model-item>

        <a-form-model-item label="是否过期">
          <a-switch
            :checked="form.is_expired === 1"
            @change="handleExpiredChange"
            checked-children="是"
            un-checked-children="否"
          />
        </a-form-model-item>
      </a-form-model>
    </a-modal>

    <a-modal
      title="图片预览"
      :visible="showImgStatus"
      :footer="null"
      @cancel="showImgStatus = false"
      :width="500"
    >
      <img style="width: 100%; max-width: 450px" :src="currentImg" />
    </a-modal>
  </div>
</template>

<script>
import MyTable from "@/components/myTable.vue";
import MyUpload from "@/components/myUpload.vue";
import { wechatTask_index, wechatTask_add } from "@/api/manager";

export default {
  components: { MyTable, MyUpload },
  data() {
    return {
      IMGHOST: window.IMGHOST,
      apiUrl: wechatTask_index,
      ajaxparams: {},
      dialogVisible: false,
      submitLoading: false,
      showImgStatus: false,
      currentImg: "",
      form: {
        title: "",
        content: "",
        img: "",
        user_levels: [],
        user_ids: "",
        forbidden_user_ids: "",
        is_expired: 0,
      },
      columns: [
        { title: "ID", dataIndex: "id", key: "id", width: 80 },
        { title: "任务名称", dataIndex: "title", key: "title", width: 150 },
        {
          title: "图片",
          dataIndex: "img",
          key: "img",
          width: 100,
          scopedSlots: { customRender: "img" },
        },
        {
          title: "发送内容",
          dataIndex: "content",
          key: "content",
          width: 200,
          scopedSlots: { customRender: "content" },
        },
        {
          title: "用户等级",
          dataIndex: "user_levels",
          key: "user_levels",
          width: 200,
          scopedSlots: { customRender: "user_levels" },
        },
        {
          title: "用户ID",
          dataIndex: "user_ids",
          key: "user_ids",
          width: 150,
          scopedSlots: { customRender: "user_ids" },
        },
        {
          title: "屏蔽用户ID",
          dataIndex: "forbidden_user_ids",
          key: "forbidden_user_ids",
          width: 150,
          scopedSlots: { customRender: "forbidden_user_ids" },
        },
        {
          title: "是否过期",
          dataIndex: "is_expired",
          key: "is_expired",
          width: 100,
          scopedSlots: { customRender: "is_expired" },
        },
        // {
        //   title: "完成进度",
        //   dataIndex: "progress",
        //   key: "progress",
        //   width: 150,
        //   scopedSlots: { customRender: "progress" },
        // },
        {
          title: "创建时间",
          dataIndex: "create_at",
          key: "create_at",
          width: 180,
        },
        {
          title: "更新时间",
          dataIndex: "update_at",
          key: "update_at",
          width: 180,
        },
      ],
    };
  },
  created() {},
  mounted() {},
  methods: {
    // 搜索
    search() {
      this.$refs.myTable.search();
    },

    showImgPopup(img) {
      if (img) {
        this.currentImg = this.IMGHOST + img;
        this.showImgStatus = true;
      }
    },

    splitCommaString(str) {
      if (!str) return [];
      return str
        .split(/[,，]/)
        .map((item) => item.trim())
        .filter((item) => item);
    },

    normalizeCommaString(str) {
      if (!str) return "";
      return str.replace(/，/g, ",").replace(/\s*,\s*/g, ",");
    },

    handleUserIdsInput() {
      if (this.form.user_ids) {
        this.form.user_ids = this.normalizeCommaString(this.form.user_ids);
      }
    },

    handleForbiddenUserIdsInput() {
      if (this.form.forbidden_user_ids) {
        this.form.forbidden_user_ids = this.normalizeCommaString(
          this.form.forbidden_user_ids
        );
      }
    },

    handleExpiredChange(checked) {
      this.form.is_expired = checked ? 1 : 0;
    },

    // 显示添加对话框
    showAddDialog() {
      this.dialogVisible = true;
      this.resetForm();
    },

    // 取消对话框
    cancelDialog() {
      this.dialogVisible = false;
      this.resetForm();
    },

    // 重置表单
    resetForm() {
      this.form = {
        title: "",
        content: "",
        img: "",
        user_levels: [],
        user_ids: "",
        forbidden_user_ids: "",
        is_expired: 0,
      };
    },

    // 上传成功回调
    uploadResult(result) {
      console.log("🚀 ~ uploadResult ~ result:", result);
      if (result && result.url) {
        this.form.img = result.url;
      }
    },

    // 删除图片回调
    uploadRemove() {
      this.form.img = "";
    },

    // 提交任务
    submitTask() {
      // 表单验证
      if (!this.form.title) {
        this.$message.error("请输入任务名称");
        return;
      }
      if (!this.form.content) {
        this.$message.error("请输入发送内容");
        return;
      }
      if (!this.form.user_levels || this.form.user_levels.length === 0) {
        this.$message.error("请选择用户等级");
        return;
      }

      this.submitLoading = true;

      const postData = {
        title: this.form.title,
        content: this.form.content,
        img: this.form.img,
        user_levels: Array.isArray(this.form.user_levels)
          ? this.form.user_levels.join(",")
          : this.normalizeCommaString(this.form.user_levels),
        user_ids: this.normalizeCommaString(this.form.user_ids),
        forbidden_user_ids: this.normalizeCommaString(
          this.form.forbidden_user_ids
        ),
        is_expired: this.form.is_expired,
      };

      wechatTask_add(postData).then((res) => {
        this.submitLoading = false;
        if (res) {
          this.$message.success("添加任务成功");
          this.dialogVisible = false;
          this.resetForm();
          this.$refs.myTable.getList();
        }
        setTimeout(() => {
          this.submitLoading = false;
        }, 1500);
      });
    },
  },
};
</script>

<style scoped>
.img {
  height: 40px;
  max-width: 60px;
  object-fit: cover;
  border-radius: 4px;
}

.w150 {
  width: 150px;
}

.mt10 {
  margin-top: 10px;
}
</style>
